import { useState } from "react";

const btn_google_signin_dark_normal_web = new URL(
	"../../../../../img/btn_google_signin_dark_normal_web.png?as=webp",
	//@ts-ignore
	import.meta.url
);

const btn_google_signin_dark_pressed_web = new URL(
	"../../../../../img/btn_google_signin_dark_pressed_web.png?as=webp",
	//@ts-ignore
	import.meta.url
);

export default function SignInWithGoogleButton(props: { href: string }) {
	const [isPressed, setIsPressed] = useState(false);

	const imageUrl = isPressed
		? btn_google_signin_dark_pressed_web
		: btn_google_signin_dark_normal_web;

	return (
		<a
			href={props.href}
			className="mx-auto"
			onMouseDown={() => {
				setIsPressed(true);
			}}
			onMouseUp={() => {
				setIsPressed(false);
			}}
		>
			<img className="m-1" src={imageUrl as unknown as string} />
		</a>
	);
}
